module.exports = __webpack_public_path__ + "img/Akute_Gefahr_durch_elektrischen_Strom.bd08fd1d.svg";